import { useFormikContext } from "formik";
import { OrDropdown } from "../shared_modules/ui/components/atoms/or-dropdown/or-dropdown";
import { useSectors } from "./useSectors";

export function SectorSelect(props) {
  const [sectors] = useSectors();
  const { setFieldValue } = useFormikContext();

  let view = "";

  if (sectors) {
    view = (
      <div className="or-auth-form__group">
        <OrDropdown
          disableClearable={true}
          errorText={props.touched.sector ? props.errors.sector : ""}
          getOptionLabel={(option) => {
            let id = option;
            if (option.id) {
              id = option.id;
            }

            const selectedSector = sectors.find((sector) => sector.id === id);
            return selectedSector ? selectedSector.name : "";
          }}
          hasError={props.touched.sector && Boolean(props.errors.sector)}
          isOptionEqualToValue={(option, selectedValue) => {
            const selectedId = typeof selectedValue === "string" ? selectedValue : selectedValue && selectedValue.id;
            return option.id === selectedId;
          }}
          label="Sector *"
          name="sector"
          onChange={(_event, value) => {
            if (value) {
              setFieldValue("sector", value.id);
            }
          }}
          options={sectors}
          value={sectors.find((sector) => sector.id === props.value) || null}
        />
      </div>
    );
  }

  return view;
}
